import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { AnalyticsWidgetComponent } from '@enginuity/analytics/organisms/analytics-widget/analytics-widget.component';
import { AnalyticsRangeContext, ComparePeriod } from '@services/analytics-services/core';
import { DashboardStore } from '../dashboard/dashboard.store';
import { AnalyticsTrendWidgetComponent } from '@enginuity/analytics/organisms/analytics-trend-widget/analytics-trend-widget.component';
import { DashboardCustomersStore } from '../dashboard-customers/dashboard-customers.store';
import { DashboardOrdersStore } from '../dashboard-orders/dashboard-orders.store';
import { DashboardProductsStore } from '../dashboard-products/dashboard-products.store';
import { FunnelChartComponent } from '@enginuity/analytics/organisms/funnel-chart/funnel-chart.component';
import { map, tap } from 'rxjs';
import { mapOverallCheckoutToFunnelData } from '@services/analytics-services/core/checkout-funnel.mapper';

@Component({
  selector: 'app-dashboard-overview',
  imports: [
    AnalyticsWidgetComponent,
    AsyncPipe,
    AnalyticsTrendWidgetComponent,
    FunnelChartComponent,
  ],
  templateUrl: './dashboard-overview.component.html',
  styleUrl: './dashboard-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DashboardCustomersStore, DashboardOrdersStore, DashboardProductsStore],
})
export class DashboardOverviewComponent {
  protected productWiseCheckOutStats$ = this.dashboardProductsStore
    .getProductWiseCheckOutStats()
    .pipe(
      map(stats => {
        if (!stats?.length) return null;
        const firstStat = stats[0];
        if (
          !firstStat ||
          typeof firstStat.total_carts_created !== 'number' ||
          typeof firstStat.total_orders_completed !== 'number'
        ) {
          console.warn('Malformed checkout stats data:', firstStat);
          return null;
        }
        return mapOverallCheckoutToFunnelData(stats[0]);
      }),
      tap(mappedStats => {
        console.log('Mapped funnel data:', mappedStats);
      })
    );
  protected productAnalytics$;
  protected customerAnalytics$ = this.dashboardCustomersStore.getCustomerAnalytics();
  protected orderAnalytics$ = this.dashboardOrdersStore.getOrderAnalytics();
  protected comparePeriod!: ComparePeriod;
  protected context!: AnalyticsRangeContext;

  constructor(
    private readonly dashboardStore: DashboardStore,
    private readonly dashboardCustomersStore: DashboardCustomersStore,
    private readonly dashboardOrdersStore: DashboardOrdersStore,
    private readonly dashboardProductsStore: DashboardProductsStore
  ) {
    this.dashboardStore.getComparePeriod().subscribe(period => (this.comparePeriod = period));
    this.dashboardStore.getRangeContext().subscribe(context => {
      this.context = context;
      this.fetchAnalytics();
    });

    this.productAnalytics$ = this.dashboardStore.getProductAnalytics();
  }

  private fetchAnalytics() {
    this.dashboardStore.loadProductsAnalytics().subscribe();
  }
}
